import React, { useEffect, useState } from 'react';
import axios from 'axios';
import BASE_URL from '../../../config/config';
import { FiClipboard, FiUsers, FiFolder } from 'react-icons/fi';
import DashboardStats from './DashboardStats';
import DashboardQuickAccess from './DashboardQuickAccess';

/**
 * Dashboard para administradores: estadísticas de tickets + accesos
 * a gestión de tickets, usuarios y tracking de proyectos.
 */
const DashboardAdmin = ({ tokenInfo, onLinkClick }) => {
  const [totalTickets, setTotalTickets] = useState(0);
  const [totalUsuarios, setTotalUsuarios] = useState(0);
  const [totalProyectos, setTotalProyectos] = useState(0);
  const [cargandoTotales, setCargandoTotales] = useState(true);
  const token = localStorage.getItem('AuthToken');

  useEffect(() => {
    const fetchTotales = async () => {
      setCargandoTotales(true);
      try {
        const [usuariosResp, ticketsResp, proyectosResp] = await Promise.all([
          axios.get(`${BASE_URL}/todos-usuarios-conteo`),
          axios.get(`${BASE_URL}/tickets/total-conteo`, { headers: { Authorization: token } }),
          axios.get(`${BASE_URL}/proyectos`),
        ]);
        setTotalUsuarios(usuariosResp.data.total || 0);
        setTotalTickets(ticketsResp.data.total || 0);
        setTotalProyectos(proyectosResp.data.proyectos?.length || 0);
      } catch (err) {
        console.error('Error al obtener totales del dashboard:', err);
      } finally {
        setCargandoTotales(false);
      }
    };
    fetchTotales();
  }, [token]);

  const cards = [
    {
      to: '/dashboard/tickets',
      icon: FiClipboard,
      color: 'azul',
      title: 'Gestionar Tickets',
      description: 'Responde y administra tickets de todos los departamentos.',
      value: totalTickets,
      valueLabel: 'Incidencias abiertas',
    },
    {
      to: '/dashboard/usuarios',
      icon: FiUsers,
      color: 'verde',
      title: 'Gestionar Usuarios',
      description: 'Administra y verifica los usuarios de la plataforma.',
      value: totalUsuarios,
      valueLabel: 'Usuarios registrados',
    },
    {
      to: '/dashboard/gestion-proyectos',
      icon: FiFolder,
      color: 'morado',
      title: 'Tracking de Proyectos',
      description: 'Informa al cliente de las fases de realización de su proyecto.',
      value: totalProyectos,
      valueLabel: 'Proyectos activos',
    },
  ];

  return (
    <div className="dash-panel">
      <div className="dash-welcome">
        <h1>Bienvenido, {tokenInfo.nombre}</h1>
        <p>Accede rápido a la gestión de tickets, usuarios y ajustes del sistema.</p>
      </div>

      <div className="dash-section">
        <span className="dash-section-title">Estadísticas generales</span>
        <DashboardStats />
      </div>

      <div className="dash-section">
        <span className="dash-section-title">Accesos rápidos</span>
        {cargandoTotales ? (
          <div className="dash-tickets-loading">Cargando accesos rápidos...</div>
        ) : (
          <DashboardQuickAccess cards={cards} onLinkClick={onLinkClick} />
        )}
      </div>
    </div>
  );
};

export default DashboardAdmin;
